import { render, staticRenderFns } from "./StausLabel.vue?vue&type=template&id=5789f68c&"
import script from "./StausLabel.vue?vue&type=script&lang=js&"
export * from "./StausLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports